var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#BFDFF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6449_367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33344 12.3665C8.65115 11.269 10.3118 10.6679 12.0268 10.6679C13.7417 10.6679 15.4024 11.269 16.7201 12.3665M4.94678 9.99986C6.89506 8.2825 9.40297 7.33496 12.0001 7.33496C14.5972 7.33496 17.1052 8.2825 19.0534 9.99986M9.68678 14.7399C10.3636 14.259 11.1732 14.0007 12.0034 14.0007C12.8337 14.0007 13.6433 14.259 14.3201 14.7399M12.0001 17.3332H12.0068",
    stroke: "#2D97E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6449_367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIcon);
export default __webpack_public_path__ + "static/media/wifi-icon.1bf12630782c2d64d259db2bfc75b90b.svg";
export { ForwardRef as ReactComponent };